'use strict'

const breakpoints = [{
    label: 'xs', min: 0, max: 575
  }, {
    label: 'sm', min: 576, max: 967
  }, {
    label: 'md', min: 968, max: 1255
  }, {
    label: 'lg', min: 1256, max: 1575
  }, {
    label: 'xl', min: 1576, max: 1847
  }, {
    label: 'xxl', min: 1848, max: 100000
  }]

export function CurrentBreakpoint() {
  if (typeof window !== 'undefined') {
    const container         = window.innerWidth
    const currentBreakpoint = breakpoints.filter(breakpoint =>
      (container >= breakpoint.min) && (container <= breakpoint.max)
    )

    return currentBreakpoint[0].label
  }
}

export function LessThanBreakpoint(lessThan) {
  const targetBreakpoint = breakpoints.filter(breakpoint => breakpoint.label === lessThan)

  if (lessThan && targetBreakpoint.length > 0) {
    if (typeof window !== 'undefined') {
      const container = window.innerWidth

      return container < targetBreakpoint[0].min
    }
  } else {
    throw Error('Valid argument missing! Please provide one of the following: sm, md, lg, xl')
  }
}

export function MoreThanBreakpoint(moreThan) {
  const targetBreakpoint = breakpoints.filter(breakpoint => breakpoint.label === moreThan)

  if (moreThan && targetBreakpoint.length > 0) {
    if (typeof window !== 'undefined') {
      const container = window.innerWidth

      return container > targetBreakpoint[0].max
    }
  } else {
    throw Error('Valid argument missing! Please provide one of the following: xs, sm, md, lg')
  }
}

export default { CurrentBreakpoint, LessThanBreakpoint, MoreThanBreakpoint }
